import axios from "axios";

// Configure axios defaults globally
console.log(
  "🔧 Configuring axios with baseURL:",
  process.env.REACT_APP_API_BASE_URL,
);

if (!process.env.REACT_APP_API_BASE_URL) {
  console.error(
    "⚠️ REACT_APP_API_BASE_URL is not set in environment variables!",
  );
}

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL || "";
axios.defaults.withCredentials = true;

console.log("✅ Axios configured with baseURL:", axios.defaults.baseURL);

// Add request interceptor to ensure Authorization header is included
axios.interceptors.request.use(
  (config) => {
    // Log the request URL for debugging
    console.log(
      `🔗 API Request: ${config.method?.toUpperCase()} ${config.baseURL}${config.url}`,
    );
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add response interceptor for error handling
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      console.error(
        "🔒 Unauthorized request - token may be invalid or missing",
      );
    }
    return Promise.reject(error);
  },
);

export default axios;
